import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { State, getLanguage, getLegalEntity } from '@cemex/cmx-client-layout';
import { Store, select } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { getCurrentLanguageWithLocaleInfo } from '@ordersnproducts/utils/utils';
import { Features } from '@ordersnproducts/features';
import { CX_INPUT_DATE_FIRST_DAY_OF_WEEK_TOKEN } from 'app/shared/cx-ui/cx-input-date/cx-input-date.config';
import { of } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay, switchMap } from 'rxjs/operators';

export const cxDateFirstDayOfWeekProvider = {
  provide: CX_INPUT_DATE_FIRST_DAY_OF_WEEK_TOKEN,
  deps: [Store, FeatureToggleService, TranslateService],
  useFactory: (store: Store<State>, featureToggle: FeatureToggleService, ts: TranslateService) => {
    return of(0).pipe(
      switchMap((firstDayOfWeek) => {
        if (featureToggle.isFeatureEnabled(Features.DATE_FIRST_DAY_WEEK_BY_DEFAULT_UI)) {
          return store.pipe(
            select(getCurrentLanguageWithLocaleInfo),
            map((defaultLang) => {
              if (defaultLang === undefined) {
                console.warn('☸ Time format by Default Language is enabled, but missing match for language');
                return firstDayOfWeek;
              }

              if (defaultLang['firstWeekDay'] === undefined) {
                console.warn('☸ Time format by Default Language is enabled, but missing a key "firstDayOfWeek"');
                return firstDayOfWeek;
              }

              return defaultLang['firstWeekDay'];
            }),
          );
        }

        return of(firstDayOfWeek);
      }),
      switchMap((firstDayOfWeek) => {
        if (featureToggle.isFeatureEnabled(Features.DATE_FIRST_DAY_WEEK_BY_LANG_UI)) {
          return store.pipe(
            select(getLanguage),
            switchMap((code) => ts.getTranslation(code)),
            map((lang) => {
              if (lang['global.FirstWeekDay'] === undefined) {
                console.warn(
                  '☸ Date format by Language is enabled, but missing translation key "global.FirstWeekDay"',
                );
                return firstDayOfWeek;
              }

              return lang['global.FirstWeekDay'];
            }),
          );
        }

        return of(firstDayOfWeek);
      }),
      switchMap((firstDayOfWeek) => {
        if (featureToggle.isFeatureEnabled(Features.DATE_FIRST_DAY_WEEK_BY_COUNTRY_UI)) {
          return store.pipe(
            select(getLegalEntity),
            filter((legalEntity) => !!legalEntity),
            map((legalEntity) => legalEntity.countryCode.trim()),
            map((country) => {
              switch (country) {
                default: {
                  return firstDayOfWeek;
                }
              }
            }),
          );
        }

        return of(firstDayOfWeek);
      }),
      distinctUntilChanged(),
      shareReplay(),
    );
  },
};
